<div class="alert-dialog-box">
  <div class="close-button" (click)="closeAlert()">
    <mat-icon>close</mat-icon>
  </div>
  <div class="alert-title">{{ data.title }}</div>
  <div
    class="alert-message"
    [ngStyle]="{ 'padding-top': data.canAddPadding === false ? '0px' : '32px' }"
  >
    {{ data.alertMessage }}
  </div>
  <div class="actions" align="end">
    <button
      mat-button
      mat-dialog-close
      class="add-btn cancel"
      (click)="closeDialogue(true)"
    >
      {{ data.buttonTextForCancel || 'No' }}
    </button>
    <button mat-button class="add-btn" (click)="closeDialogue(false)">
      {{ data.buttonText }}
    </button>
  </div>
</div>
